import React from 'react';
import { graphql } from "gatsby"
import Layout from "../components/layout"
import TransitionLink from "gatsby-plugin-transition-link"
import {GatsbyImage,getImage} from 'gatsby-plugin-image'
import formatPrice from '../utils/formatPrice';
import {useShoppingCart} from 'use-shopping-cart';
import '../styles/products.scss';
import {exitAnimation,entryAnimation} from '../utils/animation';
import SEO from "../components/seo"

export default function CategoryList ({data,classes,pageContext}) {
    const { addItem } = useShoppingCart()
    const {
        prices
    } = data
    return (
        <Layout>
            <SEO title={`Category: ${pageContext.title}`} keywords={pageContext.title} >
            </SEO>
            <h1 style={{
                textAlign: 'center'
            }}>Category: {pageContext.title}</h1>
            <ul className='grid fade' style={{
                listStyle: 'none',
                margin: 0,
                padding: 0,
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fill, minmax(360px,1fr))',
                gridGap: '1em'
            }}>
                {prices.edges.map(({ node: price }) => (
                    <li key={price.id}
                        className="product"
                    >
                        <TransitionLink to={`/${price.product.name.toLowerCase().replace(/ /g, '-')}`}
                        exit={{
                            trigger: ({exit, node}) => exitAnimation(exit,node),
                            length: 1
                        }}
                        entry={{
                            trigger: ({entry,node}) => entryAnimation(entry,node),
                            length: 1,
                            delay: 1
                        }}
                        >
                            <GatsbyImage alt={price.product.name} image={getImage(price.product.localFiles[0])} />
                            <p><b>{price.product.name}</b></p>
                            <p><span>{formatPrice(price.unit_amount,price.currency)}</span></p>
                        </TransitionLink>
                        <button
                            onClick={() => addItem({
                                sku: price.id,
                                name: price.product.name,
                                price: price.unit_amount,
                                currency: price.currency
                            })}
                        ><span>Add To Cart</span></button>
                        <script type="application/ld+json" dangerouslySetInnerHTML={{
                        __html: `{
                            "@context": "https://schema.org/",
                            "@type": "Product",
                            "name": "${price.product.name}",
                            "image": ["${typeof window !== `undefined` ? window.location.origin : ''}${price.product.localFiles[0].publicURL}"],
                            "description": "${price.product.description}",
                            "sku": "${price.id}",
                            "offers": {
                            "@type": "Offer",
                            "price": "${(price.unit_amount / 100).toFixed(2)}",
                            "priceCurrency": "${price.currency}"
                            }
                        }`
                        }}>
                        </script>
                    </li>
                ))}
            </ul>
        </Layout>
    )
}

export const query = graphql`
  query CategoryFilter($title: String) {
    prices: allStripePrice(
        filter: {product: {metadata: {category: {eq: $title}}}},
        sort: { fields: [unit_amount] }
    ) {
        edges {
            node {
              id
              active
              currency
              unit_amount
              product {
                id
                name
                description
                localFiles {
                    childImageSharp {
                        gatsbyImageData(
                          placeholder: BLURRED,
                          formats: [AUTO,WEBP,AVIF],
                          transformOptions: {fit:CONTAIN}
                        )
                    }
                    publicURL
                }
              }
            }
        }
    }
  }
`